import binocularsIllustration from '../../assets/images/illustrations/binoculars.png';
import { NavLink } from 'react-router';
import { useTranslation } from '@/hooks/useTranslation';

export function NotFoundScreen() {
  const { t } = useTranslation();
  
  return (
    <div className="p-8 flex flex-col gap-4 w-full items-center justify-center bg-blue-50 h-screen">
      <img src={binocularsIllustration} alt="" className="w-56 grayscale" />
      <h1>{t('not_found.title')}</h1>
      <p className="max-w-2xl text-center text-gray-500">
        {t('not_found.description')}
      </p>
      <NavLink to="/">
        <button className="primary">{t('global:backToHome')}</button>
      </NavLink>
    </div>
  );
}
